import {apiFetch} from "../api"

import {BASE_URL} from "../../commonUrls";


const BASE = `${BASE_URL}/user`;

export async function signup(data){
  //alert("imported url data "+ BASE_URL);
  //alert("formed url "+ BASE);

  const res = await apiFetch(`${BASE}/signup`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify(data)
  });
  return res.json();
}

export async function login(username,password){
  //alert("imported url data "+ BASE_URL);
  //alert("formed url "+ BASE);
  const res = await apiFetch(`${BASE}/login`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify({ username,password })
  });
  return res.json();
}

export async function forgotPassword(username){
  return apiFetch(`${BASE}/forgot-password`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify({ username })
  });
}

export async function resetPassword(token,newPassword){
  return apiFetch(`${BASE}/reset-password`,{
    method:"POST",
    headers:{ "Content-Type":"application/json"},
    body: JSON.stringify({ token,newPassword })
  });
}
